
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import BackgroundSection from './components/BackgroundSection';
import ExperienceSection from './components/ExperienceSection';
import SkillsSection from './components/SkillsSection';
import PersonalSection from './components/PersonalSection';

export default function AboutPage() {
  useEffect(() => {
    // Update document title and meta tags
    document.title = "About - Esteban's Stache | Creative Designer & Photographer";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Learn about my background, experience, and creative journey as a photographer of 20+ years and a designer with 8+ years of experience in brand identity, visual strategy, and design solutions. Based in Los Angeles, working with purpose-driven brands worldwide.');
    }
    
    // Update canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', '/about');
    }
    
    // Add Schema.org JSON-LD for AboutPage
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "About - Esteban's Stache",
        "description": "Learn about my background, experience, and creative journey as a photographer of 20+ years and a designer with 8+ years of experience in brand identity, visual strategy, and design solutions.",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`,
        "mainEntity": {
          "@type": "Person",
          "name": "Esteban",
          "jobTitle": "Creative Designer & Photographer",
          "description": "Photographer of 20+ years and designer with 8+ years of experience in brand identity, visual strategy, and design solutions",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Los Angeles",
            "addressRegion": "CA",
            "addressCountry": "US"
          },
          "knowsAbout": ["Photography", "Brand Identity Design", "Visual Strategy", "Design Solutions", "Creative Direction"],
          "hasOccupation": {
            "@type": "Occupation",
            "name": "Creative Designer & Photographer",
            "occupationLocation": {
              "@type": "City",
              "name": "Los Angeles"
            }
          }
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "About",
              "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/about`
            }
          ]
        }
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AboutHero />
        <BackgroundSection />
        <ExperienceSection />
        <SkillsSection />
        <PersonalSection />
      </main>
      <Footer />
    </div>
  );
}
